import {
  Button,
  Checkbox,
  Dropdown,
  MultiSelectDropdown,
  typography,
} from '@joor/design-system'
import styled from 'styled-components'

const dropdownStyles = `
  margin-bottom: 14px;
  border-radius: 4px !important;
  border-color: var(--color-primary-400) !important;

  & input {
    font-family: var(--font-family-alpha) !important;
    line-height: var(--line-height-16) !important;
    width: auto !important;
  }

  &:hover {
    border-color: var(--color-primary-800) !important;
  }

  &&& {
    min-height: 16px;
    min-width: 350px;
    box-sizing: unset;
  }
`

export const MultiOptionsDropdown = styled(MultiSelectDropdown)`
  ${dropdownStyles}
`

export const OptionsDropdown = styled(Dropdown)`
  ${dropdownStyles}
`

export const OptionsLabel = styled.label`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-800) !important;
  margin: 0;
`

export const OptionCheckbox = styled(Checkbox)`
  &&& {
    margin-top: 14px;
    margin-bottom: 0;
    padding: 0;
  }
`

export const DownloadButton = styled(Button)`
  width: 192px;
  align-self: flex-end;
`

export const HorizontalLine = styled.hr`
  margin-top: 14px;
  margin-bottom: 14px;
  border-top: 1px solid var(--color-neutral-300);
`

export const DownloadDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const Container = styled.div`
  padding: 0 16px 16px 16px;
  background-color: var(--color-secondary-100);
  display: grid;
  grid-template-columns: 4fr 2fr;
  grid-gap: 24px;
`

export const DropdownContainer = styled.div`
  & div > label {
    width: 100%;
    margin: 0;
  }
`
